// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","593":"fail"}[chunkId] + "." + {"443":"195ac786","593":"0fa39213"}[chunkId] + ".css";
};